import {combineEpics, wsCommonEpics} from "@pledger/frontend-commons";
import {enrollmentTokenWSEpics} from "./enrollmentToken/enrollmentTokenWServiceEpics";
import {enrollmentWSEpics} from "./enrollment/enrollmentWServiceEpics";
import {loginWSEpics} from "./login/loginWServiceEpics";
import {accountWSEpics} from "./account/accountWServiceEpics";
import {souscriptionCGPWSEpics} from "./SouscriptionCGP/souscriptionCGPWServiceEpics";
import {souscriptionSelfcareWSEpics} from "./SouscriptionSelfcare/souscriptionSelfcareWServiceEpics";
import {loanRequestStatusesWSEpics} from "./LoanRequestStatuses/loanRequestStatusesWServiceEpics";
import {contactWSEpics} from "./contact/contactWServiceEpics";
import {resetPasswordWSEpics} from "./resetPassword/resetPasswordWServiceEpics";
import {renewPasswordWSEpics} from "./renewPassword/renewPasswordWServiceEpics";
import {changePasswordWSEpics} from "./changePassword/changePasswordWServiceEpics";
import {changeEmailWSEpics} from "./changeEmail/changeEmailWServiceEpics";
import {changePhoneNumberWSEpics} from "./changePhoneNumber/changePhoneNumberWServiceEpics";
import {souscriptionSuiviWSEpics} from "./SouscriptionSuivi/souscriptionSuiviWServiceEpics";
import {webAuthnWSEpics} from "./webAuthn/webAuthnWServiceEpics";


const wsEpics = {
    ...wsCommonEpics,
    ...enrollmentTokenWSEpics,
    ...enrollmentWSEpics,
    ...loginWSEpics,
    ...accountWSEpics,
    ...souscriptionSelfcareWSEpics,
    ...souscriptionCGPWSEpics,
    ...loanRequestStatusesWSEpics,
    ...contactWSEpics,
    ...resetPasswordWSEpics,
    ...renewPasswordWSEpics,
    ...changePasswordWSEpics,
    ...changeEmailWSEpics,
    ...changePhoneNumberWSEpics,
    ...souscriptionSuiviWSEpics,
    ...webAuthnWSEpics
};


function buildWebServicesEpics() {
    const epicsValues  = Object.values(wsEpics);
    return combineEpics(...epicsValues);
}

export const webServicesEpics = buildWebServicesEpics();
